import React from "react";
import { connect } from "react-redux";
import { Formik, Form, FormikProps, Field } from "formik";

import { create } from "../redux/actions/itemsAction";
import Search from "../../../DataEntry/Search";

class AddForm extends React.Component<any, any> {
  handleAddItem = (data: any, formik: any) => {
    const { create, scheduleId } = this.props;

    return create(scheduleId, data).then(() => {
      formik.resetForm();
    });
  };

  render() {
    const { addAllowed, items, viewOnly } = this.props;
    const disabled = viewOnly || !addAllowed;

    return (
      <Formik initialValues={{}} onSubmit={this.handleAddItem}>
        {(_: FormikProps<any>) => (
          <Form id="search-form" className="smart-form">
            <Field
              name="item_id"
              component={Search}
              wrapper={{ style: { display: "inline-block", width: "51%" } }}
              options={disabled ? [] : items}
              placeholder="Select Item"
              isDisabled={disabled}
              isSearchable
            />
            <button
              type="submit"
              className="sn-transparent-btn sn-icons"
              disabled={disabled}
            >
              <i
                className={`fa fa-plus-circle text-success fa-2x${disabled ? " disabled" : ""}`}
                style={{
                  verticalAlign: "middle",
                  ...(disabled ? { cursor: "not-allowed" } : {}),
                }}
              />
            </button>
          </Form>
        )}
      </Formik>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  addAllowed: state.permissions.data.schedule_add_shipped_item,
  items: state.items.data.map((item: any) => ({
    value: item.item_id,
    label: `${item.description} SKU: ${item.sku || ""}`,
  })),
});

const mapDispatchToProps = { create };

export default connect(mapStateToProps, mapDispatchToProps)(AddForm);
